import { getOssBookJSON, getOssBookPageJSON } from '../../api/ossBook'
import { transFormBookDataFromNewToOld } from '../utils'

export default {
  namespaced: true,
  state: {
    bookData: {}
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    setBookData(state, payload) {
      const { workbookId, data } = payload
      state.bookData = {
        ...state.bookData,
        [workbookId]: {
          ...state.bookData[workbookId],
          ...data
        }
      }
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {
    async getBookJSON({ state, commit }, { workbookId }) {
      const { bookData } = state
      if (bookData[workbookId] && bookData[workbookId].bookJSON) {
        return bookData[workbookId].bookJSON
      }
      const data = await getOssBookJSON(workbookId)
      // 展开book,插入相关数据
      const bookJSON = { ...data, ...data.book }
      transFormBookDataFromNewToOld(bookJSON)
      commit('setBookData', {
        workbookId,
        data: {
          bookJSON
        }
      })
      return JSON.parse(JSON.stringify(bookJSON))
    },
    async getChapterJSON({ state, commit, dispatch }, { workbookId, chapterId }) {
      const { bookData } = state
      let cache = {}
      if (bookData[workbookId] && bookData[workbookId].chapterJSON) {
        cache = bookData[workbookId].chapterJSON
      }
      if (cache[chapterId]) {
        return cache[chapterId]
      }
      const data = await getOssBookPageJSON(workbookId, chapterId)
      const bookJSON = await dispatch('getBookJSON', { workbookId })
      // 兼容旧数据结构
      data.pages.forEach((item, index) => {
        data.pages[index] = {
          ...item,
          ...bookJSON.allPages.find((i) => i.id === item.id).oldData
        }
      })
      cache[chapterId] = data
      commit('setBookData', {
        workbookId,
        data: {
          chapterJSON: cache
        }
      })
      return JSON.parse(JSON.stringify(data))
    },
    async getPageJSON({ dispatch }, { workbookId, chapterId, pageId }) {
      const chapterJSON = await dispatch('getChapterJSON', { workbookId, chapterId })
      const pageJSON = JSON.parse(JSON.stringify(chapterJSON.pages.find((i) => i.id === pageId)))
      pageJSON.chapterJSON = chapterJSON
      return pageJSON
    },
    // 检查是否有看密卷下载或者看答案页的权限
    async checkMjRights({ state, dispatch, rootState }, { workbookId, bookData, pageNo }) {
      const {
        user: { userInfo }
      } = rootState
      let bookRightJSON = bookData
      const ret = {
        blankDownload: null,
        answerView: null
      }
      if (!bookRightJSON) {
        bookRightJSON = await dispatch('getBookJSON', { workbookId })
      }

      // 会员或者该密卷空白页免费下载
      ret.blankDownload = userInfo.vipLevel === 'sv' || bookRightJSON.blankFree
      // 会员或者该密卷答案页免费看
      ret.answerView = userInfo.vipLevel === 'sv' || bookRightJSON.answerFree
      // 第一页免费看
      if (pageNo === 1) {
        ret.answerView = true
      }
      const retMoreMessage = {
        ...ret,
        pageNo,
        'userInfo.vipLevel': userInfo.vipLevel,
        blankFree: bookRightJSON.blankFree,
        answerFree: bookRightJSON.answerFree
      }

      return retMoreMessage
    }
  }
}
